module.exports = __webpack_public_path__ + "fonts/Inter-900-vietnamese82.9df1755.woff2";